// Modules
import React, { useEffect } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

// Style helpers
import { addGlobalStyleTag, removeGlobalStyleTag } from './utils/styleHelpers';

// Styles
import 'fontsource-open-sans/index.css';
import 'fontsource-roboto/index.css';
import styles from './Layout.module.scss';

// Init font awesome for app
library.add(fas, far);

const Layout = (props) => {
  const { children } = props;

  useEffect(() => {
    addGlobalStyleTag();
    return () => {
      removeGlobalStyleTag();
    };
  }, []);

  return <div className={styles.container}>{children}</div>;
};

export default Layout;
